import joi from 'joi';

export interface LevelAttributes {
  id: string;
  programId: string;
  i18nAttributes: LevelI18nAttributes;
  minCurrencyAmount: number;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  isNew?: boolean;
}

export interface LevelTranslation {
  name: string;
  description: string;
  image?: string;
}

export interface LevelI18nAttributes {
  [key: string]: LevelTranslation;
}

export const $i18nAttributes = joi.object<LevelI18nAttributes, true>().pattern(
  // TODO should we validate this ?
  joi.string() /*.valid(...Object.values(SYSTEM_LANGUAGES.map(({ isoCode }) => isoCode)))*/,
  joi.object({
    name: joi.string(),
    description: joi.string().trim(),
    image: joi.string().optional().empty(''),
  }),
);

export interface AddLevelBody {
  id: string;
  i18nAttributes: LevelI18nAttributes;
  minCurrencyAmount: number;
  isNew: true;
}

export const $addLevelBody = joi.object<AddLevelBody>({
  i18nAttributes: $i18nAttributes,
  minCurrencyAmount: joi.number(),
});

export interface UpdateLevelBody {
  id: string;
  i18nAttributes: LevelI18nAttributes;
  minCurrencyAmount: number;
  isNew: false;
}

export const $updateLevelBody = joi.object<UpdateLevelBody>({
  i18nAttributes: $i18nAttributes,
  minCurrencyAmount: joi.number(),
});

export const $levelAttributes = joi.object<LevelAttributes>({
  id: joi.string(),
  programId: joi.string().optional(),
  i18nAttributes: $i18nAttributes,
  minCurrencyAmount: joi.number().min(0),
  createdAt: joi.string().isoDate().optional(),
  updatedAt: joi.string().isoDate().optional(),
  deletedAt: joi.string().isoDate().optional(),
});
